import { render, staticRenderFns } from "./EventoGeral.vue?vue&type=template&id=b2145dcc"
import script from "./EventoGeral.vue?vue&type=script&lang=js"
export * from "./EventoGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports